<template>
	<div>
		<el-card shadow="never">
			<div>
				<el-form size="small" :inline="true" label-position="right" label-width="100px" :rules="rules" :model="formData">
					<el-form-item label="发票号" prop="invoiceNo">
						<el-input
							size="small"
							style="width: 250px"
							v-model="formData.invoiceNo"
							placeholder="请输入发票号"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item label="开票时间" prop="invoiceTime">
						<el-date-picker
							size="small"
							style="width: 250px"
							v-model="formData.invoiceTime"
							type="datetime"
							placeholder="选择开票时间"
						>
						</el-date-picker>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSave">保存</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";

export default {
	name: "EditInvoiceInfoForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				invoiceNo: [{ required: true, message: "请输入发票号", trigger: "blur" }],
                invoiceTime: [{ required: true, message: "选择开票时间", trigger: "blur" }],
			},
		};
	},
	methods: {
		doSave() {
            const url = '/meter/web/order/invoiceInfo';
            this._doSaveForm(this.$refs.form, url, 'PUT');
		},
	},
};
</script>
